import {
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'lib-dropdown-content',
  templateUrl: './dropdown-content.component.html',
  styleUrls: ['./dropdown-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DropdownContentComponent implements OnInit {
  @Input() dropDirection: 'right' | 'left' = 'left';
  @Output() droplistToggle = new EventEmitter<boolean>();
  @ViewChild('content') childComp: ElementRef;
  @ContentChild('rows') rows!: TemplateRef<any>;
  @ContentChild('trigger') trigger!: TemplateRef<any>;
  isListVisible = false;
  constructor() {}

  /*   ngAfterViewInit(): void {
    this.childComp.nativeElement.addEventListener('click', () => {
      this.isListVisible = !this.isListVisible;
    });
  } */

  ngOnInit(): void {}

  handleTriggerClick(e: Event) {
    e.stopPropagation();
    this.isListVisible = !this.isListVisible;
    this.droplistToggle.emit(this.isListVisible);
  }

  closeDropdown() {
    this.isListVisible = false;
    this.droplistToggle.emit(this.isListVisible);
  }
}
